var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.722,
    height: 8.722,
    viewBox: "0 0 8.722 8.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M7.822,6.662a3.451,3.451,0,1,0-1.161,1.16L9,10.162,10.162,9Zm-2.941.349A2.128,2.128,0,1,1,7.011,4.884,2.131,2.131,0,0,1,4.882,7.011Z",
    transform: "translate(-1.44 -1.44)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e834fda27f7d1b1f2f8f44957f43f360.svg";
export { ForwardRef as ReactComponent };